module.exports = {
  platform: 'voice',
  name: 'Note',
  node: 'note',
  bg: '#FFFFFF',
  note: ''
}
